// extracted by mini-css-extract-plugin
module.exports = {"IdeaDetailPageWrapper":"IdeaDetailPage_IdeaDetailPageWrapper__1tuLr"};